import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export let globalNavigate;

export const setGlobalNavigate = (navigateFunction) => {
    globalNavigate = navigateFunction;
};

export const GlobalNavigate = () => {
    const navigate = useNavigate();
    useEffect(() => {
        setGlobalNavigate(navigate);
    }, [navigate]);
    return null; // This component doesn't render anything visually
};